import { CheckOutlined, InboxOutlined } from '@ant-design/icons';
import { Button, Form, Input, Select, Upload, message } from 'antd';
import { cx } from 'emotion';
import get from 'lodash/get';
import { useState } from 'react';
import WebIcon from 'src/_shared/components/WebIconComponent.jsx';
import { USER_ROLES } from 'src/_shared/constants/';
import { COLORS } from '../../_shared/styles/colors';
import {
	CheckIcon,
	FormItemStyles,
	FormStyles,
	InputStyles,
	LabelStyles,
	SubmitBtn as SubmitButton,
	SubmitBtnContainer as SubmitButtonContainer,
} from './editUserProfileFormStyles.js';
import { SelectContainer, SelectStyles, SortDown } from './selectStyles.js';

const EditUserProfileForm = ({
	user,
	currentUser,
	departments,
	onUpdate,
	handleError,
}) => {
	const [form] = Form.useForm();
	const [selectedDepartment, setSelectedDepartment] = useState({
		key: user.departmentId,
		label: user.department ? user.department.name : null,
	});

	const handleSelect = (value) => {
		setSelectedDepartment(value);
	};

	const handleSubmit = async () => {
		try {
			const values = await form.validateFields();
			onUpdate({
				input: {
					avatar: user.avatar,
					firstName: values.firstName,
					lastName: values.lastName,
					title: values.title,
					departmentId: selectedDepartment.key,
					emailAddress: get(values, 'email', '').toLowerCase(),
					companyId: user.companyId,
					role: user.role,
					active: user.active,
					id: user.id,
				},
			});
		} catch (error) {
			handleError();
		}
	};

	const { Option } = Select;
	const options = [];
	for (const department of departments) {
		options.push(<Option key={department.id}>{department.name}</Option>);
	}

	const disabled = currentUser.displayAs !== USER_ROLES.ADMIN;
	const uploadProps = {
		name: 'file',
		multiple: false,
		action: '//jsonplaceholder.typicode.com/posts/',
		onChange(info) {
			const { status } = info.file;
			if (status === 'done') {
				message.success(`${info.file.name} file uploaded successfully.`);
			} else if (status === 'error') {
				message.error(`${info.file.name} file upload failed.`);
			}
		},
	};

	return (
		<Form form={form} className={{ FormStyles }}>
			<Form.Item
				className={FormItemStyles}
				name="avatar"
				valuePropName="avatar"
			>
				<div>
					<label className={LabelStyles}>
						New Profile Picture:
						<Upload.Dragger className={InputStyles} {...uploadProps}>
							<p>
								<InboxOutlined />
							</p>
							<p>
								Click here to upload new profile picture, or drag a file to this
								area to upload.
							</p>
						</Upload.Dragger>
					</label>
				</div>
			</Form.Item>
			<Form.Item
				className={cx(InputStyles, FormItemStyles)}
				name="firstName"
				initialValue={user.firstName}
				rules={[{ required: true, message: 'Please input First Name!' }]}
			>
				<div>
					<label className={LabelStyles}>First Name:</label>
					<Input placeholder="First Name" />
				</div>
			</Form.Item>
			<Form.Item
				className={cx(InputStyles, FormItemStyles)}
				name="lastName"
				initialValue={user.lastName}
				rules={[{ required: true, message: 'Please input Last Name!' }]}
			>
				<div>
					<label className={LabelStyles}>Last Name:</label>
					<Input placeholder="Last Name" />
				</div>
			</Form.Item>
			<Form.Item className={cx(InputStyles, FormItemStyles)}>
				<label className={LabelStyles}>Department:</label>
				<div className={SelectContainer}>
					<Select
						labelInValue
						defaultValue={{
							key: user.departmentId,
							label: user.department ? user.department.name : null,
						}}
						className={SelectStyles}
						value={{
							key: selectedDepartment.key,
							label: selectedDepartment.label,
						}}
						showArrow={false}
						placeholder={
							<p style={{ fontSize: 16, margin: 0 }}>Add a Department</p>
						}
						onSelect={(value) => handleSelect(value)}
					>
						{options}
					</Select>
					<WebIcon
						className={SortDown}
						color={COLORS.darkGray}
						size={14}
						name="sort-down"
					/>
				</div>
			</Form.Item>
			<Form.Item
				className={cx(InputStyles, FormItemStyles)}
				name="title"
				initialValue={user.title}
				rules={[{ required: true, message: 'Please input your job title!' }]}
			>
				<div>
					<label className={LabelStyles}>Job Title:</label>
					<Input placeholder="Job Title" />
				</div>
			</Form.Item>
			<Form.Item
				className={cx(InputStyles, FormItemStyles)}
				name="email"
				initialValue={user.emailAddress}
				rules={[
					{ required: true, message: 'Please enter your email address!' },
				]}
			>
				<div>
					<label className={LabelStyles}>Email:</label>
					<Input disabled={disabled} placeholder="Email" />
				</div>
			</Form.Item>
			<Form.Item className={SubmitButtonContainer}>
				<Button
					className={SubmitButton}
					htmlType="submit"
					onClick={handleSubmit}
				>
					Submit
					<CheckOutlined className={CheckIcon} />
				</Button>
			</Form.Item>
		</Form>
	);
};

export default EditUserProfileForm;
